import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import WrappedMap from '../../../commonComponents/WrappedMap';

import iconRDH from '../../../../images/rdh_icon.svg';
import iconRDA from '../../../../images/da_icon.svg';
import iconDN from '../../../../images/dn_icon.svg';
import FrontDeskIcon from '../../../../images/fd_icon.svg';
import EfdaIcon from '../../../../images/efda_icon.svg';
import iconOffice from '../../../../images/office_icon.svg';
import InputNumber from '../../../commonComponents/InputNumber';
import { MultiStatePicker } from '../../../commonComponents/MultiStatePicker';
import { TabViewContainer } from '../../../commonComponents/TabViewContainer';

const MIN_RADIUS = 1;
const MAX_RADIUS = 50;
const DEFAULT_RADIUS = 25;

export default () => {
  const currentUser = useSelector((state) => state.users.currentUser);
  const surroundingUserList = useSelector((state) => state.users.surroundingUserList);

  const [filter, setFilter] = useState({
    profession: 'all',
    state: undefined,
    status: 'all',
  });

  const [radius, setRadius] = useState(DEFAULT_RADIUS);

  const getIcon = (key) => {
    if (key === 'RDH') return iconRDH;
    if (key === 'DA') return iconRDA;
    if (key === 'EFDA') return EfdaIcon;
    if (key === 'DN') return iconDN;
    if (key === 'FD') return FrontDeskIcon;
    if (key === 'OFFICE') return iconOffice;

    return null;
  };

  const handleValueChange = (field, value) => {
    setFilter({ ...filter, [field]: value });
  };

  const renderLegend = ({ title, count, Icon, styles }) => (
    <div style={{ display: 'flex', width: '300px', ...styles }}>
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '200px',
        }}
      >
        <img src={Icon} alt="icon" style={{ width: '24px', height: '24px', marginRight: 5 }} />
        <span style={{ fontSize: '24px' }}>{title}</span>
      </span>
      <span style={{ fontSize: '24px' }}>
        <strong>{count}</strong>
      </span>
    </div>
  );

  const renderTotal = () => {
    if (currentUser.user_type === 'DNT') {
      return (
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {renderLegend({
              title: 'Dental Offices',
              count: 1,
              Icon: getIcon('OFFICE'),
            })}
          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {Object.keys(surroundingUserList).map((key) =>
              renderLegend({
                title: key,
                count: surroundingUserList[key].length,
                Icon: getIcon(key),
                styles: { width: '180px' },
              }),
            )}
          </div>
          {/* Filter Goes Here */}
          <div
            style={{
              flex: 1,
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
            }}
          >
            <div>
              <div style={{ fontSize: '14px' }}>Profession Type: </div>
              <select
                className="custom-select custom-select-lg"
                style={{ position: 'relative', width: '150px' }}
                value={filter.profession}
                onChange={(e) => handleValueChange('profession', e.target.value)}
              >
                <option className="dropdown-item" value="all">
                  All
                </option>
                <option className="dropdown-item" value="rdh">
                  RDH
                </option>
                <option className="dropdown-item" value="da">
                  DA
                </option>
                <option className="dropdown-item" value="efda">
                  EFDA
                </option>
                <option className="dropdown-item" value="dn">
                  DN
                </option>
                <option className="dropdown-item" value="dnt">
                  DNT
                </option>
              </select>
            </div>
            <div>
              <div style={{ fontSize: '14px' }}>State:</div>
              <MultiStatePicker
                style={{ width: '150px' }}
                optionsStyle={{ width: '150px' }}
                value={filter.state}
                onChange={(value) => handleValueChange('state', value)}
              />
            </div>
            <div>
              <div style={{ fontSize: '14px' }}>Radius: </div>
              <InputNumber
                style={{ width: '150px' }}
                value={radius}
                onChange={(value) => setRadius(value)}
                min={MIN_RADIUS}
                max={MAX_RADIUS}
                step={5}
              />
            </div>
            <div>
              <div style={{ fontSize: '14px' }}>Active/Inactive: </div>
              <select
                className="custom-select custom-select-lg mb-3"
                style={{ position: 'relative', width: '150px' }}
                value={filter.status}
                onChange={(e) => handleValueChange('status', e.target.value)}
              >
                <option className="dropdown-item" value="all">
                  All
                </option>
                <option className="dropdown-item" value="active">
                  Active
                </option>
                <option className="dropdown-item" value="inactive">
                  Inactive
                </option>
              </select>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {renderLegend({
          title: 'Dental Offices',
          count: surroundingUserList?.length,
          Icon: getIcon('OFFICE'),
        })}
      </div>
    );
  };
  return (
    <TabViewContainer style={{ width: '60%', paddingInline: '15px' }} title="Map" variant="card">
      <div style={{ marginBottom: '15px' }}>{renderTotal()}</div>
      <div
          style={{
            height: '500px',
            width: '100%',
            position: 'relative',
          }}
        >
        <WrappedMap filter={filter} radius={radius} />
      </div>
    </TabViewContainer>
  );
};
